export const TOP_LEVEL_ROUTES = {
  ROOT: "/",
  SIGN_UP: "/sign-up",
  CREATE_PASSWORD: "/create-password",
  RESET_PASSWORD: "/forgot-password",
  RESET_PASSWORD_CONFIRMATION: "/user/password",
  LOGIN: "/login",
  LOGIN_2FA: "/otp",
  RECOVER_ACCOUNT: "/recover-account",
  USE_RECOVERY_CODE: "/recover-account/recovery-code",
  USE_RECOVERY_EMAIL: "/recover-account/verify-via-email",
  EMAIL_OTP: "/recover-account/verify-via-email/otp",
  LOGOUT: "/logout",
  AUTHENTICATION: "/Authenticator",
  NOT_FOUND: "*",
  VERIFY: "/get-verified",
  SETUP2FA: "/setup-2FA",
  ADD_COMPANY: "/add-company",
  APPLICATIONS: "/applications",
  CHECKS: "/screening",
  MONITORING: "/monitoring",
  PROFILES: "/profiles",
  SERVER_ERROR: "/error",
  Download: "/download",

  APPLICATION: "/applications/:id",
  APPLICATION_NEW: "/applications/new",
  APPLICATION_INDIVIDUALS: "/applications/:id/individuals",
  APPLICATION_INDIVIDUALS_NEW: "/applications/:id/individuals/new",
  ACTIVATE_APPLICATIONS_INDIVIDUAL_MONITORING:
    "/applications/activate-monitoring-individual/:id",
  ACTIVATE_APPLICATIONS_MONITORING:
    "/applications/:mandate/activate-monitoring/:id",

  CHECKS_NEW: "/screening/new",
  CHECKS_NEW_COMPANY: "/screening/new/company",
  CHECK_INDIVIDUALS: "/screening/:id/individuals",
  CHECK_INDIVIDUALS_NEW: "/screening/individuals/new",
  CHECK_COMPANY_NEW_DETAILS: "/screening/new/company/details",
  CHECK_ADDRESS_NEW: "/screening/:id/address/:individualId",
  CHECK_NEW_COMPANY_ADDRESS: "/screening/:id/company/address/:entityId",
  RUN_CHECKS: "/screening/:id/run-screening/:individualId",
  RUN_COMPANY_CHECKS: "/screening/:id/company/run-screening/:entityId",
  CHECKS_INDIVIDUAL: "/screening/:mandate/individuals/:id",
  ACTIVATE_CHECKS_MONITORING_INDIVIDUAL:
    "/screening/activate-monitoring-individual/:individualId",
  ACTIVATE_CHECKS_MONITORING:
    "/screening/:mandate/activate-monitoring/:individualId",
  CHECK_MONITORING: "/screening/:id/monitoring/:individualId",
  CHECKS_COMPANY: "/screening/:mandate/company/:id",

  MONITORING_INDIVIDUAL: "/monitoring/:id",
  MONITORING_NEW: "/monitoring/new",
  MONITORING_NEW_COMPANY: "/monitoring/new/company",
  MONITORING_NEW_CONFIRM: "/monitoring/new/confirm",
  MONITORING_NEW_COMPANY_CONFIRM: "/monitoring/company/new/confirm",

  PROFILE_NEW_ENTITY: "/profiles/new/entity",
  PROFILE_NEW_ENTITY_ADDRESS: "/profiles/new/entity/address",
  PROFILE_NEW_ENTITY_SUMMARY: "/profiles/new/entity/summary",
  PROFILE_NEW_PERSON: "/profiles/new/person",
  PROFILE_NEW_PERSON_ADDRESS: "/profiles/new/person/address",
  PROFILE_NEW_PERSON_SUMMARY: "/profiles/new/person/summary",
  PROFILE_DETAIL_VIEW: "/profile/:id",
  PROFILE_DETAIL_ORG: "/profile/:id/org",

  PROFILE_APPLICATION_ENTITY_DETAILS:
    "/profile/:id/applications/new/entity-details",
  PROFILE_APPLICATION_APPLICATION_TYPE:
    "/profile/:id/applications/new/application-type",
  PROFILE_APPLICATION_ADD_CONTACT: "/profile/:id/applications/new/add-contact",
  PROFILE_APPLICATION_SEND_INVITES:
    "/profile/:id/applications/new/send-invites",

  PROFILE_SCREENING_SELECT_CHECKS: "/profile/:id/screening/new/select-checks",

  PROFILE_SCREENING_ADD_PERSON: "/profile/:id/screening/new/add-person-entity",

  PROFILE_SCREENING_ADD_ADDRESS: "/profile/:id/screening/new/add-address",

  PROFILE_SCREENING_REVIEW: "/profile/:id/screening/new/review",

  PROFILE_MONITORING_DETAILS: "/profile/:id/monitoring/new/details",
  PROFILE_MONITORING_SUMMARY: "/profile/:id/monitoring/new/summary",

  SETTINGS: "/settings",
  SETTINGS_USERS: "/settings/users",
  SETTINGS_APPLICATION_TYPE: "/settings/application-types/:id",
  SETTINGS_APPLICATION_TYPE_NEW: "/settings/application-types/new",
  SETTINGS_APPLICATION_TYPE_NEW_CHECKS:
    "/settings/application-types/:id/screening",
  SETTINGS_APPLICATION_TYPE_NEW_FORMS: "/settings/application-types/:id/forms",
  SETTINGS_APPLICATION_TYPE_NEW_DOCUMENTS:
    "/settings/application-types/:id/documents",
  SETTINGS_APPLICATION_TYPES: "/settings/application-types",
  SETTINGS_SOF_RISK_SCORING: "/settings/sof-risk-scoring",
  SETTINGS_ADDITIONAL_DOCUMENTS_REQUESTS:
    "/settings/additional-documents-requests",
  SETTINGS_CONSULTANTS: "/settings/consultants",
  SETTINGS_DIVISIONS_TEAMS: "/settings/divisions-teams",
  SETTINGS_ROLES_PERMISSIONS: "/settings/roles-permissions",

  SETTINGS_FORMS: "/settings/forms",
  SETTINGS_FORM_NEW: "/settings/forms/new",
  SETTINGS_FORM_NEW_QUESTIONS: "/settings/forms/:id/questions",
  SETTINGS_FORM_SUMMARY: "/settings/forms/:id/summary",
  SETTINGS_FORM_VIEW: "/settings/forms/:id",
  SETTINGS_INCOME_AND_EMPLOYMENT: "/settings/income-employment",

  SETTINGS_PEP_SANCTION_SCREENING: "/settings/pep-sanctions-screening",
  SETTINGS_BILLING_DETAILS: "/settings/billing-details",
  SETTINGS_DPO_DETAILS: "/settings/dpo-details",
  SETTINGS_BRANDING: "/settings/branding",
  SETTINGS_BRANDING_SPLASH_NEW: "/settings/branding/new",
  SETTINGS_BRANDING_SPLASH: "/settings/branding/:id",
  SETTINGS_ADDRESS_HISTORY: "/settings/address-history",
  PROFILE: "/profile",
  ACCOUNT_PENDING: `/account-pending`,

  SETTINGS_PROPERTIES: "/settings/properties",
  SETTINGS_PROPERTY_ADDRESS_TYPES: "/settings/properties/address-types",
  SETTINGS_PROPERTY_INDUSTRIES: "/settings/properties/industries",
  SETTINGS_PROPERTY_SECTORS: "/settings/properties/sectors",
  SETTINGS_PROPERTY_COUNTRY: "/settings/properties/countries",
  SETTINGS_PROPERTY_ENTITY_TYPES: "/settings/properties/entity-types",
  SETTINGS_PROPERTY_RELATIONSHIP_TYPES:
    "/settings/properties/relationship-types",

  HELP_AND_SUPPORT: "/help-and-support",
};

const NESTED_ROUTES = {
  VERIFY: `${TOP_LEVEL_ROUTES.SIGN_UP}/get-verified`,
  SETUP_2FA: `${TOP_LEVEL_ROUTES.SIGN_UP}/setup-2FA`,
  ADD_COMPANY: `${TOP_LEVEL_ROUTES.SIGN_UP}/add-company`,
  ADD_COMPANY_ADDRESS: `${TOP_LEVEL_ROUTES.SIGN_UP}/add-company-address`,
  ADD_BILLING_INFORMATION: `${TOP_LEVEL_ROUTES.SIGN_UP}/add-billing-information`,
  ADD_BILLING_ADDRESS: `${TOP_LEVEL_ROUTES.SIGN_UP}/add-billing-address`,
  ADD_PRIMARY_PURPOSE: `${TOP_LEVEL_ROUTES.SIGN_UP}/add-primary-purpose-details`,
  ADD_DPO: `${TOP_LEVEL_ROUTES.SIGN_UP}/DPO-details`,
};

const APPLICATION = {
  INDIVIDUAL: `${TOP_LEVEL_ROUTES.APPLICATION}/individuals/:id`,
};

export const ROUTE = {
  ...TOP_LEVEL_ROUTES,
  ...NESTED_ROUTES,
  ...APPLICATION,
};
